export const DangerIcon = ({ color = "#ED553B", size = 19, ...props }) => (
    <svg
        width={size}
        height={size * (14 / 19)}
        viewBox="0 0 19 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0 14H19L9.5 0L0 14ZM10.3636 11.7895H8.63636V10.3158H10.3636V11.7895ZM10.3636 8.8421H8.63636V5.89474H10.3636V8.8421Z"
            fill={color}
        />
    </svg>
);
